import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import tourService from '../../services/tourService';

const NavigationTour = ({ isActive, onComplete, autoStart = false, userStatus = {} }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isActive && autoStart && !tourService.isTourCompleted('main_onboarding')) {
      // Start main onboarding tour for new users
      setTimeout(() => {
        tourService.startTour('main_onboarding', navigate, userStatus);
        if (onComplete) {
          // Set up completion callback
          setTimeout(() => {
            if (onComplete) onComplete();
          }, 1000);
        }
      }, 1500);
    } else if (isActive && !autoStart) {
      // Manual trigger - start appropriate tour based on user status
      const tourName = userStatus.hasResume && userStatus.hasProfile ? 'dashboard' : 'main_onboarding';
      setTimeout(() => {
        tourService.startTour(tourName, navigate, userStatus);
        if (onComplete) {
          setTimeout(() => {
            if (onComplete) onComplete();
          }, 1000);
        }
      }, 500);
    }
  }, [isActive, autoStart, navigate, userStatus, onComplete]);

  // Cleanup when component unmounts
  useEffect(() => {
    return () => {
      if (tourService.currentTour) {
        tourService.cancelTour();
      }
    };
  }, []);

  // This component now just manages the tour lifecycle
  // The actual tour rendering is handled by Shepherd.js
  return null;
};

export default NavigationTour;